import {css} from '@emotion/css';
import '../../styles/global';

export function makeStyles() {
    return css`
        position: relative;
        height: 100%;
    `;
}
